import FreshbooksIntegration from './FreshbooksIntegration';
export default FreshbooksIntegration;
